/**
 * 쿠폰 API
 */
import { apiNa } from "@/redworks/api/index";
import { api } from "@/redworks/api/index";

const COUPON_API = "/v1/coupon";

function $rejectAcceptEmail(rejectInfo) {
  const rejectDto = {
    rejectInfo: encodeURIComponent(rejectInfo)
      .replace(/%20/g, "+")
      .replace(/%2F/g, "/"),
  };
  return apiNa.put(`${COUPON_API}/reject`, rejectDto);
}

function $createRequestParam(returnUrl) {
  const data = {
    returnUrl: returnUrl,
  };
  const queryString = Object.keys(data)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
    .join("&");
  return apiNa.post(`${COUPON_API}/identify/key?${queryString}`);
}

function $getResData(params) {
  return apiNa.post(`${COUPON_API}/identify/decode`, params);
}

function $isUsableLoginId(loginId) {
  return apiNa.get(`${COUPON_API}/validate-identity/${loginId}`);
}

function $isUsableIdentifyValue(verifyIdVal) {
  return apiNa.get(`${COUPON_API}/validate-verify`, {
    params: { ci: verifyIdVal },
  });
}

function $signupCustomer(params) {
  return apiNa.post(`${COUPON_API}/sign-up`, params);
}

function $withdrawCustomer(params) {
  return apiNa.delete(`${COUPON_API}/withdraw`, params);
}

function $changeActive(custId) {
  return apiNa.put(`${COUPON_API}/active/${custId}`);

}
function $creBarCode(params) {
  return apiNa.post(`${COUPON_API}/creBarcode`, params);
}
function $couponCodeExchange(params) {
  return apiNa.post(`${COUPON_API}/couponCodeExchange`, params);
}
function $useCoupon(params) {
  return apiNa.post(`${COUPON_API}/useCoupon`, params);
}
function $oferCouponDetail(key) {
  return apiNa.get(`${COUPON_API}/oferCouponDetail/${key}`);
}

//Coupon List
function $getCouponList(param){
  return apiNa.get(`${COUPON_API}`, {params : param});
}
//Coupon Detail
function $getCouponDetail(couponMstId){
  return apiNa.get(`${COUPON_API}/${couponMstId}`);
}

// 쿠폰 회수 API
function $withdrawCoupon(param, token) {
  return apiNa.put(`${COUPON_API}/withdraw`, param, {
    headers: {
      Authorization: `${token}`
    }
  });
}
// 쿠폰 취소 API
function $cancelCoupon(params, token) {
  return apiNa.put(`${COUPON_API}/cancel`, params, {
    headers: {
      Authorization: `${token}`
    }
  });
}
// 쿠폰 사용 API
function $usingCoupon(params, token) {
  return apiNa.put(`${COUPON_API}/using`, params ,{
      headers : {
        Authorization : `${token}`
      }
  });
}

// 쿠폰 발행 목록 조회
function $getIssuedCouponList(param) {
  return api.get(`${COUPON_API}/issue-list`, { params: param });
}



export {
  $rejectAcceptEmail,
  $createRequestParam,
  $getResData,
  $isUsableLoginId,
  $signupCustomer,
  $withdrawCustomer,
  $changeActive,
  $isUsableIdentifyValue,
  $creBarCode,
  $couponCodeExchange,
  $useCoupon,
  $oferCouponDetail,
  $getCouponList,
  $getCouponDetail,
  $withdrawCoupon,
  $cancelCoupon,
  $usingCoupon,
  $getIssuedCouponList

}
